import React from "react";
import { useState, useEffect } from 'react';
import { fetchWithAuth } from "../../auth"
import AddRoom from "../../dialogs/addRoom"
import ModifyRoom from "../../dialogs/modifyRoom"

import '../../index.css';

function gf_getType(type) {
    switch (type) {
      case 0: return 'Cucina'
      case 1: return 'Stanza da letto'
      case 2: return 'Bagno'
      case 3: return 'Postazione lavoro'
      default: return '?'
    }
  }

const RoomsTableDB = ({
    serial
}) => {
    const [mysqlRoomsState, setMysqlRoomsState] = useState([]);

    async function fetchrooms() {
        await fetchWithAuth('/rooms/' + serial, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                setMysqlRoomsState(data)
            })
    }

    useEffect(() => {
        fetchrooms()
    }, [serial]);

    async function deleteRoom(event) {
        let _id = event.target.getAttribute('id_arg');
        await fetchWithAuth('/room', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: _id })
        })
        fetchrooms()
    }

    const [openAddRoom, setOpenAddRoom] = useState(false);
    const handleCloseAddRoom = () => {
        setOpenAddRoom(false)
        fetchrooms()
    };
    const handleOpenAddRoom = () => {
        setOpenAddRoom(true)
    };

    const [openModifyRoom, setOpenModifyRoom] = useState(false);
    const [modifyRoomId, setModifyRoomId] = useState();
    const [modifyRoomType, setModifyRoomType] = useState('');
    const [modifyRoomName, setModifyRoomName] = useState('');
    const handleCloseModifyRoom = () => {
        setOpenModifyRoom(false)
        fetchrooms()
    };
    const handleOpenModifyRoom = (event) => {
        setModifyRoomId(event.target.getAttribute('id_arg'))
        setModifyRoomType(event.target.getAttribute('type_arg'))
        setModifyRoomName(event.target.getAttribute('name_arg'))
        setOpenModifyRoom(true)
    };

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <AddRoom isOpen={openAddRoom} onClose={handleCloseAddRoom} gw={serial} />
            <ModifyRoom isOpen={ openModifyRoom } onClose = { handleCloseModifyRoom } id = {modifyRoomId} currentType = {modifyRoomType} currentRoomName = {modifyRoomName}/>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px', backgroundColor: 'green', color: 'white', fontWeight: 'bold' }}>
                {isOpen ? 'Nascondi Rooms' : 'Mostra Rooms'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle_db" colSpan="3">Stanze</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
                        </tr>
                        <tr>
                            <th className="title">id stanza</th>
                            <th className="title">tipo stanza</th>
                            <th className="title">stanza</th>
                            <th style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={handleOpenAddRoom}>Aggiungi</button>
                                <button onClick={fetchrooms}>Aggiorna</button>
                            </th>
                        </tr>
                        {mysqlRoomsState.map(mapRoom => (
                            <tr key={mapRoom.id}>
                                <td>{mapRoom.id}</td>
                                <td>{gf_getType(mapRoom.type)}</td>
                                <td>{mapRoom.room}</td>
                                <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                    <button onClick={deleteRoom} id_arg={mapRoom.id}>elimina</button>
                                    <button onClick={handleOpenModifyRoom} id_arg={mapRoom.id} type_arg={mapRoom.type} name_arg={mapRoom.room}>modifica</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default RoomsTableDB;
